<template>
  <form ref="form" :autocomplete="formAutocomplete" @submit.prevent="handleSubmit">
    <m-dot-loader v-if="loading" />
    <template v-else>
      <m-alert v-if="hasSubmitted && ($slots.error || error)" theme="error" :icon="faExclamationCircle" class="my-3">
        <slot v-if="!error" name="error"></slot>
        <p v-else class="whitespace-pre-wrap">{{ errorDisplay }}</p>
      </m-alert>

      <slot />
      <m-action-list v-if="$slots.actions" :column="actionList?.column" :position="actionList?.position" class="pt-3">
        <slot name="actions"></slot>
      </m-action-list>
    </template>
  </form>
</template>
<script setup lang="ts">
  import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
  import { computed, ref, watch } from 'vue';
  import { useAutofillPolicy } from '@shared/composables/useAutofillPolicy';
  import MDotLoader from '../MDotLoader/MDotLoader.vue';
  import type { MActionListProps } from '../MActionList/MActionList.vue';
  export interface Props {
    error?: string | string[] | null;
    /**
     * Whether or not the form is loading
     * Hides content until loading is complete
     */
    loading?: boolean;
    actionList?: MActionListProps;
  }
  export interface Emits {
    (e: 'submit'): void;
  }
  const emit = defineEmits<Emits>();
  const props = withDefaults(defineProps<Props>(), { error: null, loading: false, actionList: undefined });
  const hasSubmitted = ref(false);
  const errorDisplay = computed(() => (Array.isArray(props.error) ? props.error.join('\r\n') : props.error));

  const autofillPolicy = useAutofillPolicy();
  const formAutocomplete = computed(() => (autofillPolicy.value === 'block' ? 'off' : undefined));

  watch(
    () => props.error,
    (v) => {
      if (!v) {
        hasSubmitted.value = false;
      }
    },
  );
  const handleSubmit = () => {
    hasSubmitted.value = true;
    emit('submit');
  };
  const form = ref(null);
</script>
